module.exports = __webpack_public_path__ + "img/download.293c5ae6.svg";